"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Table = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/Table"));
var _types = require("../utils/types");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "table": "TierLimits__table__2lGeI",
  "disclaimer": "TierLimits__disclaimer__151pR"
}; 
require('./TierLimits.css');
var TIER_LIMIT_HEADERS = [{
  key: 'maximumRequests',
  label: 'Requests'
}, {
  key: 'period',
  label: 'Time period'
}, {
  key: 'unit',
  label: 'Time unit'
}];
var TierLimits = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(TierLimits, _React$PureComponent);
  var _super = _createSuper(TierLimits);
  function TierLimits() {
    (0, _classCallCheck2.default)(this, TierLimits);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(TierLimits, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        testId = _this$props.testId,
        limits = _this$props.limits;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Table.default, {
        className: styles.table,
        headers: TIER_LIMIT_HEADERS,
        rows: limits,
        testId: testId
      }), limits.length === 0 ? /*#__PURE__*/_react.default.createElement("span", {
        className: styles.disclaimer
      }, "No limits to show") : null);
    }
  }]);
  return TierLimits;
}(_react.default.PureComponent);
(0, _defineProperty2.default)(TierLimits, "propTypes", {
  limits: _propTypes.default.arrayOf(_types.TierLimitShape).isRequired,
  testId: _propTypes.default.string
});
(0, _defineProperty2.default)(TierLimits, "defaultProps", {
  testId: 'tier-limits-table'
});
var _default = exports.default = TierLimits;
//# sourceMappingURL=TierLimits.js.map